export function shortenString(long: string, limit = 64) {
  if (long.length < limit) return long;
  return long.split('').slice(0, limit).concat(['...']).join('');
}
